<template>
  <div>
  <AppNavigationTop :navigationInfo="AppNavigationTopInfo"/>
  <DocumentRevsListSimple/>
  <v-layout row class="mt-4 mb-4"/>
  <AppNavigationBottom/>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AppNavigationTop from "@/frame/navigation/components/AppNavigationTop";
import DocumentRevsListSimple from "@/document/revisions/components/DocumentRevsListSimple";
import currentPage from "@/frame/pages/mixins/currentPage.js";
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";

export default {
  components: {
    AppNavigationBottom,
    AppNavigationTop,
    DocumentRevsListSimple
  },
  mixins: [currentPage],
  data() {
    return {
      currentPagePath: "/documentrevisions"
    };
  },
  computed: {
    ...mapGetters(["getCurrentPage", "getPreviousPage"]),
    AppNavigationTopInfo() {
      // temp. addition
      let temp = {
        title: "Document Revisions",
        titleColour: "wplblue0--text",
        btns: [
          {
            title: "detail",
            icon: "source",
            link: ""
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      };
      // dynamic nav bar
      temp.btns[0].link = this.getPreviousPage;
      return temp;
    }
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
  }
};
</script>
